import React from 'react';

import Title from 'components/shared/Typography/Title';

import s from './index.module.css';

function Blocker({ text }) {
  return (
    <blocker className={s.wrapper}>
      <div className={s.inner}>
        <Title italic level={3} weight="normal" noTransform noMargin className={s.text}>
          {text}
        </Title>
      </div>
    </blocker>
  );
}

export default Blocker;
